import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MapPin, X } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const SESSION_KEY = "loc_nudge_checked";

export function LocationNudge() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user || user.location || sessionStorage.getItem(SESSION_KEY)) return undefined;
    sessionStorage.setItem(SESSION_KEY, "1");
    let t;
    api.get("/me/location-nudge").then((r) => {
      if (!r.data.show) return;
      t = setTimeout(() => { setShow(true); api.post("/me/location-nudge", { action: "shown" }).catch(() => {}); }, 8000);
    }).catch(() => {});
    return () => clearTimeout(t);
  }, [user]);

  useEffect(() => { if (user?.location) setShow(false); }, [user?.location]);

  if (!show || !user || pathname.startsWith("/w/")) return null;
  const dismiss = () => { setShow(false); api.post("/me/location-nudge", { action: "dismissed" }).catch(() => {}); };
  const go = () => { setShow(false); navigate(`/w/${user.username}?edit=location`); };
  return (
    <div className="fixed bottom-5 right-5 z-[90] w-[320px] max-w-[calc(100vw-2.5rem)] rounded-2xl border border-emerald-500/30 shadow-2xl shadow-black/50 p-4 animate-slide-up"
      style={{ backgroundColor: "#131B26" }} role="status" data-testid="location-nudge">
      <button onClick={dismiss} title="Not now" data-testid="location-nudge-dismiss" className="absolute top-2.5 right-2.5 p-1 rounded-lg text-slate-500 hover:text-slate-300 hover:bg-slate-800">
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-start gap-3 pr-5">
        <span className="w-9 h-9 shrink-0 rounded-full bg-emerald-500/15 ring-1 ring-emerald-400/30 flex items-center justify-center"><MapPin className="w-4 h-4 text-emerald-300" /></span>
        <div>
          <p className="text-sm font-semibold text-slate-100">Help your pack find you</p>
          <p className="text-xs text-slate-400 mt-0.5">Add your location so nearby wolves and local dens can find you.</p>
          <button onClick={go} data-testid="location-nudge-cta"
            className="mt-2.5 inline-flex items-center gap-1.5 text-xs font-semibold rounded-full px-3.5 py-1.5 bg-emerald-500 hover:bg-emerald-400 text-slate-950 transition-colors">
            <MapPin className="w-3.5 h-3.5" /> Add location
          </button>
        </div>
      </div>
    </div>
  );
}
